import { render, staticRenderFns } from "./CustomNominalPopup.vue?vue&type=template&id=214c8871&scoped=true"
import script from "./CustomNominalPopup.vue?vue&type=script&lang=js"
export * from "./CustomNominalPopup.vue?vue&type=script&lang=js"
import style0 from "./CustomNominalPopup.vue?vue&type=style&index=0&id=214c8871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c8871",
  null
  
)

export default component.exports